import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Close";
import { AlertContext } from "../../context/AlertContext";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Menu from "./Menu";
import { jsPDF } from "jspdf";

import Barthel from "./Barthel";
import LawtonBrody from "./LawtonBrody";
import Tinetti from "./Tinetti";
import EscalaValoracionMental from "./EscalaValoracionMental";
import Reloj from "./Reloj";
import Goldberg from "./Goldberg";
import Yesavage from "./Yesavage";
import EvaluacionNutricional from "./EvaluacionNutricional";
import Fragilidad from "./Fragilidad";
import Norton from "./Norton";

const steps = [
  "Barthel",
  "Lawton y Brody",
  "Tinetti",
  "Minimental",
  "Test del Reloj",
  "Escala de Ansiedad y Depresión de Goldberg",
  "Yesavage",
  "Evaluación Nutricional",
  "Marcadores de Fragilidad",
  "Norton",
  "Resumen",
];

const detallesDiagnosticoNutricional = {
  A: "A - Bien nutrido",
  B: "B - Sospecha de malnutrición o malnutrición moderada",
  C: "C - Malnutrición severa",
};

export const calcularBarthel = (barthel) =>
  barthel
    ? Number(barthel.comer || 0) +
      Number(barthel.lavarse || 0) +
      Number(barthel.vestirse || 0) +
      Number(barthel.arreglarse || 0) +
      Number(barthel.deposiciones || 0) +
      Number(barthel.miccion || 0) +
      Number(barthel.retrete || 0) +
      Number(barthel.trasladarse || 0) +
      Number(barthel.deambular || 0) +
      Number(barthel.escalones || 0)
    : null;

export const calcularLawtonBrody = (lawtonBrody) =>
  lawtonBrody
    ? Number(lawtonBrody.telefonoResultado || 0) +
      Number(lawtonBrody.comprasResultado || 0) +
      Number(lawtonBrody.comidaResultado || 0) +
      Number(lawtonBrody.casaResultado || 0) +
      Number(lawtonBrody.ropaResultado || 0) +
      Number(lawtonBrody.transporteResultado || 0) +
      Number(lawtonBrody.medicacionResultado || 0) +
      Number(lawtonBrody.economicoResultado || 0)
    : null;

export const calcularTinetti = (tinetti) =>
  tinetti
    ? Number(tinetti.equilibrioSentado || 0) +
      Number(tinetti.levantarse || 0) +
      Number(tinetti.intentoLevantarse || 0) +
      Number(tinetti.equilibrioSegundos || 0) +
      Number(tinetti.equilibrioProlongado || 0) +
      Number(tinetti.rombergSensibilizado || 0) +
      Number(tinetti.romberg || 0) +
      Number(tinetti.girar || 0) +
      Number(tinetti.girar2 || 0) +
      Number(tinetti.sentarse || 0)
    : null;

export const calcularNorton = (norton) =>
  norton
    ? Number(norton.estadoFisico || 0) +
      Number(norton.estadoMental || 0) +
      Number(norton.actividad || 0) +
      Number(norton.movilidad || 0) +
      Number(norton.incontinencia || 0)
    : null;

export const calcularMinimental = (escalaValoracionMental) => {
  if (!escalaValoracionMental) return null;
  return (
    Number(
      escalaValoracionMental.pregunta1
        ? escalaValoracionMental.pregunta1Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta2
        ? escalaValoracionMental.pregunta2Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta3
        ? escalaValoracionMental.pregunta3Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta4
        ? escalaValoracionMental.pregunta4Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta5 ? escalaValoracionMental.pregunta5 : 0
    ) +
    Number(
      escalaValoracionMental.pregunta6
        ? escalaValoracionMental.pregunta6Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta7
        ? escalaValoracionMental.pregunta7Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta8
        ? escalaValoracionMental.pregunta8Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta9
        ? escalaValoracionMental.pregunta9Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta10
        ? escalaValoracionMental.pregunta10Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta11
        ? escalaValoracionMental.pregunta11Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta12
        ? escalaValoracionMental.pregunta12Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta13
        ? escalaValoracionMental.pregunta13Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta14
        ? escalaValoracionMental.pregunta14Value
        : 0
    ) +
    Number(
      escalaValoracionMental.pregunta15
        ? escalaValoracionMental.pregunta15Value
        : 0
    )
  );
};

const sumarPreguntasGoldberg = (goldberg, inicio) =>
  Array.from({ length: 9 }, (_, index) =>
    Number(goldberg?.[`pregunta${inicio + index * 2}`] || 0)
  ).reduce((total, valor) => total + valor, 0);

export const calcularGoldberg = (goldberg) =>
  goldberg && !Array.isArray(goldberg)
    ? `${sumarPreguntasGoldberg(goldberg, 1)} / ${sumarPreguntasGoldberg(goldberg, 2)}`
    : "";

export const calcularYesavage = (yesavage) => {
  if (!yesavage) return null;
  let total = 0;
  for (let i = 1; i <= 30; i++) {
    total += Number(yesavage[`pregunta${i}`] || 0);
  }
  return total;
};

export const calcularFragilidad = (fragilidad) => {
  if (!fragilidad) return null;
  let total = 0;
  for (let i = 1; i <= 27; i++) {
    if (fragilidad[`pregunta${i}`]) {
      total += Number(fragilidad[`pregunta${i}Value`] || 0);
    }
  }
  return total;
};

export const calcularReloj = (reloj) =>
  reloj
    ? Number(reloj.esfera || 0) +
      Number(
        reloj.numero && reloj.numero / 10 === 3.5
          ? reloj.numero / 10
          : reloj.numero && reloj.numero / 10 !== 3.5
          ? Math.trunc(reloj.numero / 10)
          : 0
      ) +
      Number(
        reloj.aguja && reloj.aguja / 10 === 3.5
          ? reloj.aguja / 10
          : reloj.aguja && reloj.aguja / 10 !== 3.5
          ? Math.trunc(reloj.aguja / 10)
          : 0
      )
    : null;

export const diagnosticoNutricional = (evaluacionNutricional) =>
  detallesDiagnosticoNutricional[
    evaluacionNutricional?.diagnosticoNutricional
  ] || "-";

export const parseEstudio = (json) => {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

export default function ValoracionGeriatricaIntegral(props) {
  let navigate = useNavigate();
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState(null);

  const [dialogPacientes, setDialogPacientes] = useState(false);
  const [dialogValoraciones, setDialogValoraciones] = useState(false);
  const [dialogNueva, setDialogNueva] = useState(false);
  const [dialogVer, setDialogVer] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [detalleValoracion, setDetalleValoracion] = useState(null);

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    statusAcceso,
    pacientes,
    selectedRowPaciente,
    setSelectedRowPaciente,
    setGeriatricoElegido,
    obtenerPacientes,
    obtenerAcceso,
    obtenerAcceso3,
    obtenerAcceso4,
    obtenerAcceso5,
    obtenerDiagnosticos,
    valoracionesGeriatricas,
    obtenerValoracionesGeriatricas,
    agregarValoracionGeriatrica,
    barthel,
    lawtonBrody,
    tinetti,
    norton,
    escalaValoracionMental,
    goldberg,
    yesavage,
    evaluacionNutricional,
    fragilidad,
    reloj,
    guardarBarthel,
    guardarLawtonBrody,
    guardarTinetti,
    guardarNorton,
    guardarEscalaValoracionMental,
    guardarGoldberg,
    guardarYesavage,
    guardarEvaluacionNutricional,
    guardarFragilidad,
    guardarReloj,
  } = serviciosContext;

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ValoracionGeriatrica",
      });
      obtenerAcceso3({
        usuarioId: state.usuario.id,
        layout: "EditarPIHC",
      });
      obtenerAcceso4({
        usuarioId: state.usuario.id,
        layout: "Psicologia",
      });
      obtenerAcceso5({
        usuarioId: state.usuario.id,
        layout: "Nutricion",
      });
    }
  }, [state]);

  useEffect(() => {
    setGeriatricoElegido({
      id: Number(localStorage.getItem("geriatricoElegidoId")),
      nombre: localStorage.getItem("geriatricoElegidoNombre"),
    });
    obtenerPacientes({
      geriatricoId: Number(localStorage.getItem("geriatricoElegidoId")),
    });
    obtenerDiagnosticos({ todos: true });
  }, []);

  const accesoDenegado = () => {
    mensajeAlerta(
      "Acceso",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    navigate("/");
    return;
  };

  const resetEstudios = () => {
    guardarBarthel([]);
    guardarLawtonBrody([]);
    guardarTinetti([]);
    guardarNorton([]);
    guardarEscalaValoracionMental([]);
    guardarGoldberg([]);
    guardarYesavage([]);
    guardarEvaluacionNutricional([]);
    guardarFragilidad([]);
    guardarReloj([]);
  };

  const addClick = (e) => {
    setDialogPacientes(true);
    setSelectedRowPaciente(null);
  };

  const onHidePacientes = (e) => {
    setSelectedRowPaciente(null);
    setDialogPacientes(false);
  };

  const aceptarClickPacientes = (e) => {
    if (selectedRowPaciente) {
      obtenerValoracionesGeriatricas({ pacienteId: selectedRowPaciente.id });
      setDialogPacientes(false);
      setDialogValoraciones(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Valoración Geriátrica Integral",
        detail: "Debe seleccionar un residente.",
        life: 3000,
      });
    }
  };

  const onHideValoraciones = (e) => {
    setDialogValoraciones(false);
  };

  const addClickValoracion = (e) => {
    resetEstudios();
    setActiveStep(0);
    setSelectedRow(null);
    setDialogNueva(true);
  };

  const onHideNueva = (e) => {
    resetEstudios();
    setDialogNueva(false);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      guardarValoracion();
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const guardarValoracion = () => {
    agregarValoracionGeriatrica({
      paciente: selectedRowPaciente,
      barthel,
      lawtonBrody,
      tinetti,
      norton,
      escalaValoracionMental,
      goldberg,
      yesavage,
      evaluacionNutricional,
      fragilidad,
      reloj,
      usuario: state.usuario,
    });
    resetEstudios();
    setDialogNueva(false);
    obtenerValoracionesGeriatricas({ pacienteId: selectedRowPaciente.id });
  };

  const verClick = (e) => {
    if (selectedRow) {
      setDetalleValoracion({
        fecha: selectedRow.fecha,
        usuario: selectedRow.usuario,
        barthel: parseEstudio(selectedRow.barthel),
        lawtonBrody: parseEstudio(selectedRow.lawtonBrody),
        tinetti: parseEstudio(selectedRow.tinetti),
        norton: parseEstudio(selectedRow.norton),
        escalaValoracionMental: parseEstudio(selectedRow.escalaValoracionMental),
        goldberg: parseEstudio(selectedRow.goldberg),
        yesavage: parseEstudio(selectedRow.yesavage),
        evaluacionNutricional: parseEstudio(selectedRow.evaluacionNutricional),
        fragilidad: parseEstudio(selectedRow.fragilidad),
        reloj: parseEstudio(selectedRow.reloj),
      });
      setDialogVer(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Valoración Geriátrica Integral",
        detail: "Debe seleccionar una valoración.",
        life: 3000,
      });
    }
  };

  const onHideVer = (e) => {
    setDialogVer(false);
  };

  const imprimirClick = (e) => {
    if (!selectedRow) {
      toast.current.show({
        severity: "info",
        summary: "Valoración Geriátrica Integral",
        detail: "Debe seleccionar una valoración.",
        life: 3000,
      });
      return;
    }

    const detalle = {
      fecha: selectedRow.fecha,
      usuario: selectedRow.usuario,
      barthel: parseEstudio(selectedRow.barthel),
      lawtonBrody: parseEstudio(selectedRow.lawtonBrody),
      tinetti: parseEstudio(selectedRow.tinetti),
      norton: parseEstudio(selectedRow.norton),
      escalaValoracionMental: parseEstudio(selectedRow.escalaValoracionMental),
      goldberg: parseEstudio(selectedRow.goldberg),
      yesavage: parseEstudio(selectedRow.yesavage),
      evaluacionNutricional: parseEstudio(selectedRow.evaluacionNutricional),
      fragilidad: parseEstudio(selectedRow.fragilidad),
      reloj: parseEstudio(selectedRow.reloj),
    };

    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.setFont("Times", "bolditalic");
    doc.text(selectedRowPaciente ? selectedRowPaciente.nombre || "" : "", 15, 8);
    doc.rect(10, 12, 190, 20);
    doc.setFontSize(14);
    doc.text("VALORACION GERIATRICA INTEGRAL", 35, 20);
    doc.setFont("Times", "normal");
    doc.setFontSize(10);

    let row = 40;
    doc.text(
      `Fecha: ${detalle.fecha ? formatDate2(detalle.fecha) : ""}`,
      12,
      row
    );
    doc.text(`Usuario: ${detalle.usuario || ""}`, 130, row);
    row += 10;

    const filas = [
      ["ABVD Barthel", calcularBarthel(detalle.barthel)],
      ["AIVD Lawton y Brody", calcularLawtonBrody(detalle.lawtonBrody)],
      ["Tinetti", calcularTinetti(detalle.tinetti)],
      ["Minimental", calcularMinimental(detalle.escalaValoracionMental)],
      ["Test del Reloj", calcularReloj(detalle.reloj)],
      ["Goldberg (Ansiedad / Depresión)", calcularGoldberg(detalle.goldberg)],
      ["Yesavage", calcularYesavage(detalle.yesavage)],
      [
        "Diagnóstico Nutricional",
        diagnosticoNutricional(detalle.evaluacionNutricional),
      ],
      ["Fragilidad", calcularFragilidad(detalle.fragilidad)],
      ["Norton", calcularNorton(detalle.norton)],
    ];

    filas.forEach(([label, valor]) => {
      doc.text(
        `${label}: ${valor === null || valor === undefined ? "-" : valor}`,
        12,
        row
      );
      row += 8;
    });

    doc.save(
      `VGI_${selectedRowPaciente ? selectedRowPaciente.nombre : ""}_${detalle.fecha ? formatDate2(detalle.fecha) : ""}.pdf`
    );
  };

  function formatDate2(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    return newDate;
  }

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const nombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nombre</span>
        {rowData.nombre}
      </Fragment>
    );
  };

  const documentoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Documento</span>
        {rowData.numeroDocumento}
      </Fragment>
    );
  };

  const fechaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {formatDate2(rowData.fecha)}
      </Fragment>
    );
  };

  const headerPacientes = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            fullWidth
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag value="Residentes"></Tag>
      </div>
    </Fragment>
  );

  const renderFooterPacientes = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClickPacientes}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHidePacientes}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const headerValoraciones = (
    <Fragment>
      <Button
        icon="pi pi-plus"
        tooltip="Nueva valoración"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "0em" }}
        onClick={addClickValoracion}
      />
      <Button
        icon="pi pi-eye"
        tooltip="Ver"
        className="p-button-rounded p-button-success"
        style={{ marginLeft: "1em" }}
        onClick={verClick}
      />
      <Button
        icon="pi pi-print"
        tooltip="Imprimir"
        className="p-button-rounded p-button-help"
        style={{ marginLeft: "1em" }}
        onClick={imprimirClick}
      />
    </Fragment>
  );

  const renderResumen = (
    barthelValor,
    lawtonBrodyValor,
    tinettiValor,
    escalaValoracionMentalValor,
    relojValor,
    goldbergValor,
    yesavageValor,
    evaluacionNutricionalValor,
    fragilidadValor,
    nortonValor
  ) => (
    <Grid container spacing={3} style={{ padding: "1rem" }}>
      <Grid item xs={12} md={12}>
        <Typography variant="h6" style={{ textDecoration: "underline" }}>
          Resumen de la Valoración Geriátrica Integral
        </Typography>
      </Grid>
      {[
        ["ABVD Barthel", calcularBarthel(barthelValor)],
        ["AIVD Lawton y Brody", calcularLawtonBrody(lawtonBrodyValor)],
        ["Tinetti", calcularTinetti(tinettiValor)],
        ["Minimental", calcularMinimental(escalaValoracionMentalValor)],
        ["Test del Reloj", calcularReloj(relojValor)],
        ["Goldberg (Ansiedad / Depresión)", calcularGoldberg(goldbergValor)],
        ["Yesavage", calcularYesavage(yesavageValor)],
        [
          "Diagnóstico Nutricional",
          diagnosticoNutricional(evaluacionNutricionalValor),
        ],
        ["Fragilidad", calcularFragilidad(fragilidadValor)],
        ["Norton", calcularNorton(nortonValor)],
      ].map(([label, valor]) => (
        <Grid item xs={12} md={4} key={label}>
          <Typography variant="body1">
            <strong>{label}:</strong>{" "}
            {valor === null || valor === undefined ? "-" : valor}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{ align: "center", margin: "1em", marginTop: "3vw" }}
          >
            <Button
              icon="pi pi-search"
              tooltip="Pacientes"
              className="p-button-rounded p-button-help"
              style={{ marginLeft: "0em" }}
              onClick={addClick}
            />
          </Grid>

          <Grid item xs={12} style={{ margin: "1em" }}>
            <Typography variant="h5">Escalas de Valoración</Typography>
            <Typography variant="body1">
              Seleccione un residente para realizar o consultar sus
              valoraciones geriátricas integrales.
            </Typography>
          </Grid>

          <Dialog
            showHeader={false}
            visible={dialogPacientes}
            closable={false}
            footer={renderFooterPacientes()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "75vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              <Grid item xs={12} md={12}>
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <DataTable
                      value={pacientes}
                      selection={selectedRowPaciente}
                      onSelectionChange={(e) => setSelectedRowPaciente(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={headerPacientes}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={100}
                      rowsPerPageOptions={[10, 20, 50, 100, 500]}
                      responsiveLayout="scroll"
                    >
                      <Column
                        field="id"
                        header="ID"
                        body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="nombre"
                        header="Apellido y Nombre"
                        body={nombreTemplate}
                        style={{ width: "30%" }}
                        sortable
                      ></Column>
                      <Column
                        field="numeroDocumento"
                        header="Documento"
                        body={documentoTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Dialog>

          <Dialog
            header={
              selectedRowPaciente
                ? "Valoraciones de " + selectedRowPaciente.nombre
                : "Valoraciones"
            }
            visible={dialogValoraciones}
            closable={true}
            onHide={onHideValoraciones}
            breakpoints={{ "960px": "95vw" }}
            style={{ width: "90vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "0vw" }}>
              <Grid item xs={12} md={12}>
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <DataTable
                      value={valoracionesGeriatricas}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={headerValoraciones}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "0vw" }}
                      emptyMessage="No hay valoraciones cargadas."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      responsiveLayout="scroll"
                    >
                      <Column
                        field="id"
                        header="ID"
                        body={idTemplate}
                        style={{ display: "none" }}
                        sortable
                      ></Column>
                      <Column
                        field="fecha"
                        header="Fecha"
                        body={fechaTemplate}
                        sortable
                        style={{ width: "20%" }}
                      ></Column>
                      <Column field="usuario" header="Usuario" sortable></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Dialog>

          <Dialog
            header={
              "Nueva Valoración Geriátrica Integral" +
              (selectedRowPaciente ? " - " + selectedRowPaciente.nombre : "")
            }
            visible={dialogNueva}
            maximized={true}
            closable={true}
            onHide={onHideNueva}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "95vw", paddingBottom: "0" }}
            position="top"
          >
            <Box sx={{ width: "100%", padding: "1rem" }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                <ButtonMui
                  color="inherit"
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  style={{ marginLeft: "1vw" }}
                >
                  Anterior
                </ButtonMui>
                <Box sx={{ flex: "1 1 auto" }} />
                <ButtonMui onClick={handleNext}>
                  {activeStep === steps.length - 1 ? "Guardar" : "Siguiente"}
                </ButtonMui>
              </Box>

              <Fragment>
                {activeStep === 0 && selectedRowPaciente ? <Barthel /> : null}
                {activeStep === 1 && selectedRowPaciente ? (
                  <LawtonBrody />
                ) : null}
                {activeStep === 2 && selectedRowPaciente ? <Tinetti /> : null}
                {activeStep === 3 && selectedRowPaciente ? (
                  <EscalaValoracionMental />
                ) : null}
                {activeStep === 4 && selectedRowPaciente ? <Reloj /> : null}
                {activeStep === 5 && selectedRowPaciente ? <Goldberg /> : null}
                {activeStep === 6 && selectedRowPaciente ? <Yesavage /> : null}
                {activeStep === 7 && selectedRowPaciente ? (
                  <EvaluacionNutricional />
                ) : null}
                {activeStep === 8 && selectedRowPaciente ? (
                  <Fragilidad />
                ) : null}
                {activeStep === 9 && selectedRowPaciente ? <Norton /> : null}
                {activeStep === 10
                  ? renderResumen(
                      barthel,
                      lawtonBrody,
                      tinetti,
                      escalaValoracionMental,
                      reloj,
                      goldberg,
                      yesavage,
                      evaluacionNutricional,
                      fragilidad,
                      norton
                    )
                  : null}
              </Fragment>
            </Box>
          </Dialog>

          <Dialog
            header="Valoración Geriátrica Integral"
            visible={dialogVer}
            closable={true}
            onHide={onHideVer}
            breakpoints={{ "960px": "95vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            {detalleValoracion ? (
              <Fragment>
                <Grid container spacing={2} style={{ padding: "1rem" }}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1">
                      <strong>Fecha:</strong>{" "}
                      {detalleValoracion.fecha
                        ? formatDate2(detalleValoracion.fecha)
                        : ""}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1">
                      <strong>Usuario:</strong> {detalleValoracion.usuario}
                    </Typography>
                  </Grid>
                </Grid>
                {renderResumen(
                  detalleValoracion.barthel,
                  detalleValoracion.lawtonBrody,
                  detalleValoracion.tinetti,
                  detalleValoracion.escalaValoracionMental,
                  detalleValoracion.reloj,
                  detalleValoracion.goldberg,
                  detalleValoracion.yesavage,
                  detalleValoracion.evaluacionNutricional,
                  detalleValoracion.fragilidad,
                  detalleValoracion.norton
                )}
              </Fragment>
            ) : null}
          </Dialog>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
